const getArrayStringData = (data) => {
  return data.split(",");
};

export default getArrayStringData;
